<template>
  <div class='df-tip' :class="{'text-center':type===4}">
    <Tooltip :content="content" max-width="200" placement="top" :disabled="isDisabled">
      <div :class="'wot' + row">
        <more-text class="more-box" :text="content" :last-width="100" :no-change="false" :row="row" @show-more="changeMore"></more-text>
        {{content}}
      </div>
    </Tooltip>
  </div>
</template>

<script>
export default {
  name: 'DfTip',
  props: {
    content: {
      type: String | Number,
      default: ''
    },
    row: {
      type: Number | String,
      default: 1
    },
		type:{
			type:Number | String,
			default: 1
		}
  },
  data () {
    return {
      isDisabled: true,
    }
  },
  created () {
  },
  methods: {
    changeMore (bool) {
      this.isDisabled = !bool;
    },
  }
}
</script>

<style scoped lang='less'>
.text-center{
	text-align: center;
}
.more-box {
  height: 0;
  overflow: hidden;
  /deep/ .more {
    display: none;
  }
}
</style>
